import { Box, Typography } from "@mui/material";
import { useState, useRef, useEffect } from "react";

const TextReadMoreLess = ({ text }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      setIsOverflowing(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  }, [text]);

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        flexDirection: isExpanded ? "column" : "row",
      }}
    >
      <Typography
        ref={textRef}
        variant="fw400s14lh24c686868"
        sx={{
          lineHeight: "20px",
          whiteSpace: isExpanded ? "normal" : "nowrap",
          overflow: "hidden",
          textOverflow: isExpanded ? "clip" : "ellipsis",
          wordBreak: "break-word",
          overflowWrap: "anywhere",
          flex: "1 1 auto",
        }}
      >
        {text}
      </Typography>

      {isOverflowing && (
        <Typography
          variant="fw400s14lh24c686868"
          sx={{
            lineHeight: "20px",
            cursor: "pointer",
            color: "#6D72F6",
            ml: isExpanded ? 0 : 1,
            flexShrink: 0,
          }}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? "Read less" : "Read more"}
        </Typography>
      )}
    </Box>
  );
};

export default TextReadMoreLess;
